import React, { useEffect, useState } from "react";
import { PageWrapper } from "../../components/Page";
import PageHeader from "../../components/Header/PageHeader";
import { TextArea, TextInput } from "../../components/Input";
import { Grid } from "@material-ui/core";
import Checkbox from "../../components/Input/Checkbox";
import { Button } from "../../components/Button";
import { ArrowForward, ShoppingCart } from "@material-ui/icons";
import PageMenu from "../../components/Page/PageMenu";
import { Link, useHistory } from "react-router-dom";
import { ProjectActions } from "../../reducers/project/actionsNames";
import { useDispatch, useSelector } from "react-redux";
import { getCart, getCartId, getForm } from "../../reducers/project/selectors";
import { useFetch } from "../../hooks/useFetch";
import { IProject } from "../../reducers/project";
import content from "../../content";
import { Stepper } from "../../components/Header";
import { DrawerMenu } from "../../components/Menu";
import { Mobile, useDesktop } from "../../components/Responsive";

function OrderForm({}: IForm) {
  const history = useHistory();
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    notes: "",
    agree: false,
  });

  const [error, setError] = useState<any>({
    name: null,
    phone: null,
    email: null,
    notes: null,
    agree: null,
  });

  const dispatch = useDispatch();
  const formState = useSelector(getForm);
  const cart: IProject[] = useSelector(getCart);
  const cartId = useSelector(getCartId);

  const [responseUpdate, requestUpdate] = useFetch<{
    id: string;
    projects: IProject[];
  }>("/cart/", {} as any, {
    method: "PUT",
  });

  useEffect(() => {
    setForm({...formState});
  }, [formState]);

  const change = (input: string, checkbox = false) => (e) => {
    if (checkbox) {
      setForm({ ...form, [input]: e.target.checked });
    } else {
      setForm({ ...form, [input]: e.currentTarget.value });
    }
    setError({ ...error, [input]: null });
  };

  const validate = () => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const rp = /^([0-9]{9})$/;
    let errors = {};
    if (!form.name) {
      errors["name"] = "Pole nie może być puste";
    }
    if (!form.email || !re.test(String(form.email).toLowerCase())) {
      errors["email"] = "Wprowadź parawidłowy adres email";
    }
    if (!form.phone || !rp.test(String(form.phone))) {
      errors["phone"] = "Wprowadź parawidłowy numer telefonu";
    }
    if (!form.agree) {
      errors["agree"] = "Musisz wyrazić zgodę na ...";
    }
    setError({ ...error, ...errors });

    if (Object.values(errors).every((e) => !Boolean(e))) {
      requestUpdate(
        {
          projects: cart,
          client: form,
          step: "Formularz kontaktowy",
        },
        cartId
      );

      dispatch({ type: ProjectActions.SetForm, form });
      history.push("/services");
    }
  };

  const required = ["name", "phone", "email", "agree"];

  const desktop = useDesktop();

  return (
    <>
      <PageHeader header={content.getValue("header_step_1")}>
        <Stepper />
      </PageHeader>
      <PageWrapper
        menu={
          <>
            <DrawerMenu
              Icon={
                <svg
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="21" cy="21" r="21" fill="#080808" />
                  <path
                    d="M27.625 11.125H23.6667C23.6667 9.40137 22.2466 8 20.5 8C18.7534 8 17.3333 9.40137 17.3333 11.125H13.375C12.0638 11.125 11 12.1748 11 13.4688V30.6562C11 31.9502 12.0638 33 13.375 33H27.625C28.9362 33 30 31.9502 30 30.6562V13.4688C30 12.1748 28.9362 11.125 27.625 11.125ZM15.75 28.7031C15.0919 28.7031 14.5625 28.1807 14.5625 27.5312C14.5625 26.8818 15.0919 26.3594 15.75 26.3594C16.4081 26.3594 16.9375 26.8818 16.9375 27.5312C16.9375 28.1807 16.4081 28.7031 15.75 28.7031ZM15.75 24.0156C15.0919 24.0156 14.5625 23.4932 14.5625 22.8438C14.5625 22.1943 15.0919 21.6719 15.75 21.6719C16.4081 21.6719 16.9375 22.1943 16.9375 22.8438C16.9375 23.4932 16.4081 24.0156 15.75 24.0156ZM15.75 19.3281C15.0919 19.3281 14.5625 18.8057 14.5625 18.1562C14.5625 17.5068 15.0919 16.9844 15.75 16.9844C16.4081 16.9844 16.9375 17.5068 16.9375 18.1562C16.9375 18.8057 16.4081 19.3281 15.75 19.3281ZM20.5 9.95312C21.1581 9.95312 21.6875 10.4756 21.6875 11.125C21.6875 11.7744 21.1581 12.2969 20.5 12.2969C19.8419 12.2969 19.3125 11.7744 19.3125 11.125C19.3125 10.4756 19.8419 9.95312 20.5 9.95312ZM26.8333 27.9219C26.8333 28.1367 26.6552 28.3125 26.4375 28.3125H19.3125C19.0948 28.3125 18.9167 28.1367 18.9167 27.9219V27.1406C18.9167 26.9258 19.0948 26.75 19.3125 26.75H26.4375C26.6552 26.75 26.8333 26.9258 26.8333 27.1406V27.9219ZM26.8333 23.2344C26.8333 23.4492 26.6552 23.625 26.4375 23.625H19.3125C19.0948 23.625 18.9167 23.4492 18.9167 23.2344V22.4531C18.9167 22.2383 19.0948 22.0625 19.3125 22.0625H26.4375C26.6552 22.0625 26.8333 22.2383 26.8333 22.4531V23.2344ZM26.8333 18.5469C26.8333 18.7617 26.6552 18.9375 26.4375 18.9375H19.3125C19.0948 18.9375 18.9167 18.7617 18.9167 18.5469V17.7656C18.9167 17.5508 19.0948 17.375 19.3125 17.375H26.4375C26.6552 17.375 26.8333 17.5508 26.8333 17.7656V18.5469Z"
                    fill="white"
                  />
                </svg>
              }
              title={content.getValue("drawer_form_title")}
              text={content.getValue("drawer_form_text")}
            />
            <div
              style={{
                marginTop: "auto",
                width: "100%",
                padding: "24px",
                boxSizing: "border-box",
              }}
            >
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "50%" }}>
                  <Link to={"/cart"}>
                    <Button
                      variant={"text"}
                      startIcon={
                        <svg
                          width="17"
                          height="8"
                          viewBox="0 0 17 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM17 4.5H1V3.5H17V4.5Z"
                            fill="#838282"
                          />
                        </svg>
                      }
                      label={content.getValue("button_back_to_cart")}
                    />
                  </Link>
                </div>
                <div style={{ height: "20px" }} />
                <div style={{ width: "50%" }}>
                  <Button
                    color={"secondary"}
                    variant={"outlined"}
                    onClick={validate}
                    disabled={
                      Object.values(error).some((v) => Boolean(v)) ||
                      !required.every((v) => !!form[v])
                    }
                    Icon={
                      <svg
                        style={{
                          position: "absolute",
                          right: "20px",
                        }}
                        width="17"
                        height="8"
                        viewBox="0 0 17 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                          fill={
                            Object.values(error).some((v) => Boolean(v)) ||
                            !required.every((v) => !!form[v])
                              ? "rgba(0, 0, 0, 0.26)"
                              : "#C41230"
                          }
                        />
                      </svg>
                    }
                    label={content.getValue("button_next")}
                  />
                </div>
              </div>
            </div>
          </>
        }
      >
        <div style={{ width: desktop ? "70%" : "100%" }}>
          <p
            style={{
              marginBottom: "25px",
              color: "#666666",
              opacity: 0.6,
              fontSize: "14px",
            }}
          >
            {content.getValue("step_1_info")}
          </p>
          <div key={JSON.stringify(error)} style={{ marginRight: desktop ? "150px" : "unset" }}>
            <Grid
              container={true}
              spacing={desktop ? 5 : 0}
              justify={"space-between"}
            >
              <Grid sm={6} item={true} xs={12}>
                <TextInput
                  error={error["name"]}
                  value={form["name"]}
                  onChange={change("name")}
                  name={"name"}
                  inputLabel={content.getValue("form_name")}
                />
              </Grid>
              <Grid sm={6} xs={12} item={true}>
                <TextInput
                  error={error["phone"]}
                  value={form["phone"]}
                  onChange={change("phone")}
                  name={"phone"}
                  inputLabel={content.getValue("form_phone")}
                />
              </Grid>
            </Grid>
            <Grid
              container={true}
              spacing={5}
              justify={"space-between"}
            >
              <Grid sm={6} xs={12} item={true}>
                <TextInput
                  error={error["email"]}
                  value={form["email"]}
                  onChange={change("email")}
                  name={"email"}
                  inputLabel={content.getValue("form_email")}
                />
              </Grid>
            </Grid>
            <TextArea
              rows={6}
              name={"notes"}
              value={form["notes"]}
              onChange={change("notes")}
              inputLabel={content.getValue("form_notes")}
            />
            <Checkbox
              error={error["agree"]}
              value={form["agree"]}
              checked={form["agree"]}
              onChange={change("agree", true)}
              name={"check"}
              label={content.getValue("form_agreement_label")}
            />
          </div>
        </div>
        <Mobile>
          <div style={{ display: "flex", width: "100%", marginBottom: "24px" }}>
            <div style={{ width: "50%" }}>
              <Link to={"/cart"}>
                <Button
                  variant={"text"}
                  startIcon={
                    <svg
                      width="17"
                      height="8"
                      viewBox="0 0 17 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.646446 4.35355C0.451185 4.15829 0.451185 3.84171 0.646446 3.64645L3.82843 0.464466C4.02369 0.269204 4.34027 0.269204 4.53553 0.464466C4.7308 0.659728 4.7308 0.976311 4.53553 1.17157L1.70711 4L4.53553 6.82843C4.7308 7.02369 4.7308 7.34027 4.53553 7.53553C4.34027 7.7308 4.02369 7.7308 3.82843 7.53553L0.646446 4.35355ZM17 4.5H1V3.5H17V4.5Z"
                        fill="#838282"
                      />
                    </svg>
                  }
                  label={content.getValue("button_back_to_cart")}
                />
              </Link>
            </div>
            <div style={{ height: "20px" }} />
            <div style={{ width: "50%" }}>
              <Button
                color={"secondary"}
                variant={"outlined"}
                onClick={validate}
                disabled={
                  Object.values(error).some((v) => Boolean(v)) ||
                  !required.every((v) => !!form[v])
                }
                Icon={
                  <svg
                    style={{
                      position: "absolute",
                      right: "20px",
                    }}
                    width="17"
                    height="8"
                    viewBox="0 0 17 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                      fill={
                        Object.values(error).some((v) => Boolean(v)) ||
                        !required.every((v) => !!form[v])
                          ? "rgba(0, 0, 0, 0.26)"
                          : "#C41230"
                      }
                    />
                  </svg>
                }
                label={content.getValue("button_next")}
              />
            </div>
          </div>
        </Mobile>
      </PageWrapper>
    </>
  );
}

export interface IForm {}

export default OrderForm;
